import {
  FormFieldConfigType,
  INPUT_TYPES,
  TEXT_INPUT_TYPES,
  SelectFormField,
  TextInputFormField,
  TextAreaFormField,
  DatePickerFormField,
  RADIO_NO_INFORMATION,
  RadioFormField,
} from "../../../../types";
import { INCIDENT_DETAILS_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";
import {
  CLAIM_TYPE_OPTIONS,
  CURRENCY_OPTIONS,
  TYPE_OF_CLAIM_OPTIONS,
} from "../../../options";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allIncidentDetailsFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Incident Details",
    fields: [
      {
        name: INCIDENT_DETAILS_CONSTANTS.INCIDENT_DATE,
        label: "Date of Loss",
        description: "",
        type: INPUT_TYPES.DATE_PICKER,
      } as DatePickerFormField,
      {
        name: INCIDENT_DETAILS_CONSTANTS.DATE_OF_SUBMISSION,
        label: "Date of Submission",
        description: "",
        type: INPUT_TYPES.DATE_PICKER,
      },
      {
        name: INCIDENT_DETAILS_CONSTANTS.TYPE_OF_CLAIM,
        label: "Type of Claim",
        description: "",
        placeholderText: "Select Type of Claim",
        type: INPUT_TYPES.SELECT,
        options: TYPE_OF_CLAIM_OPTIONS,
      } as SelectFormField,
      {
        name: INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_DETAILS,
        columns: 2,
        fields: [
          {
            name: INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_ID,
            label: "Claim Type",
            description: "",
            placeholderText: "Select Claim Type",
            type: INPUT_TYPES.SELECT,
            options: CLAIM_TYPE_OPTIONS,
            onChange: (
              { detail }: { detail: any },
              formState: any,
              updateForm: (formState: any) => void
            ) => {
              const claimTypeId = detail.selectedOption;
              const expectedArrivalDateHidden =
                claimTypeId.label !== "Missing Cargo" &&
                claimTypeId.label !== "Damaged & Missing Cargo";
              const locationAndContactHidden =
                claimTypeId.label === "Missing Cargo";
              updateForm({
                ...formState,
                [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_ID]: {
                  ...formState[INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_ID],
                  value: claimTypeId,
                },
                [INCIDENT_DETAILS_CONSTANTS.EXPECTED_ARRIVAL_DATE]: {
                  ...formState[
                    INCIDENT_DETAILS_CONSTANTS.EXPECTED_ARRIVAL_DATE
                  ],
                  hidden: expectedArrivalDateHidden,
                },
                [INCIDENT_DETAILS_CONSTANTS.CARGO_OR_PROPERTY_LOCATION]: {
                  ...formState[
                    INCIDENT_DETAILS_CONSTANTS.CARGO_OR_PROPERTY_LOCATION
                  ],
                  hidden: locationAndContactHidden,
                },
                [INCIDENT_DETAILS_CONSTANTS.CONTACT_DETAILS]: {
                  ...formState[
                    INCIDENT_DETAILS_CONSTANTS.CARGO_OR_PROPERTY_LOCATION
                  ],
                  hidden: locationAndContactHidden,
                },
              });
            },
          } as SelectFormField,
          {
            name: INCIDENT_DETAILS_CONSTANTS.EXPECTED_ARRIVAL_DATE,
            label: "Expected Arrival Date",
            description: "",
            type: INPUT_TYPES.DATE_PICKER,
          } as DatePickerFormField,
        ],
      },
      {
        name: INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_DETAILS,
        columns: 2,
        fields: [
          {
            name: INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_CODE,
            label: "Total Claim Currency Code",
            description: "",
            placeholderText: "Select currency",
            type: INPUT_TYPES.SELECT,
            options: CURRENCY_OPTIONS,
          } as SelectFormField,
          {
            name: INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_VALUE,
            label: "Total Claim Value",
            description: "",
            placeholderText: "Value of missing/damaged items",
            type: INPUT_TYPES.CURRENCY,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
        ],
      },

      {
        name: INCIDENT_DETAILS_CONSTANTS.LOCATION_OF_INCIDENT,
        label: "Location of Incident",
        description: "",
        placeholderText: "Location of Incident (Address or Coordinates)",
        type: INPUT_TYPES.TEXTAREA,
      } as TextAreaFormField,
      {
        name: INCIDENT_DETAILS_CONSTANTS.DETAILED_INCIDENT_SUMMARY,
        label: "Detailed Incident Summary",
        description: "",
        placeholderText:
          "Please provide details of the incident resulting in the loss/damage to the cargo/property",
        type: INPUT_TYPES.TEXTAREA,
      } as TextAreaFormField,
      {
        name: INCIDENT_DETAILS_CONSTANTS.POLICE_REPORT_AVAILABLE,
        label: "Is a Police Report Available?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_NO_INFORMATION,
      } as RadioFormField,
      {
        name: INCIDENT_DETAILS_CONSTANTS.CARGO_OR_PROPERTY_LOCATION,
        label: "Cargo/Property Location",
        description: "",
        placeholderText:
          "Where is the cargo/property currently located? (If different from above)",
        type: INPUT_TYPES.TEXTAREA,
      } as TextAreaFormField,
      {
        name: INCIDENT_DETAILS_CONSTANTS.CONTACT_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: INCIDENT_DETAILS_CONSTANTS.CONTACT_DETAILS,
        columns: 3,
        fields: [
          {
            name: INCIDENT_DETAILS_CONSTANTS.CONTACT_NAME,
            label: "Contact Name",
            description: "",
            placeholderText: "Enter contact name",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: INCIDENT_DETAILS_CONSTANTS.CONTACT_PHONE_NUMBER,
            label: "Contact Phone Number",
            description: "",
            placeholderText: "Enter contact phone number",
            type: INPUT_TYPES.PHONE,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
          {
            name: INCIDENT_DETAILS_CONSTANTS.CONTACT_EMAIL_ADDRESS,
            label: "Contact Email Address",
            description: "",
            placeholderText: "Enter contact email address",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.EMAIL,
          } as TextInputFormField,
        ],
      },
      {
        name: INCIDENT_DETAILS_CONSTANTS.ADDITIONAL_INFORMATION,
        label: "Additional Information",
        description: "",
        placeholderText:
          "Please supply any additional information to support your claim",
        type: INPUT_TYPES.TEXTAREA,
      } as TextAreaFormField,
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
